/**
 * Cash & Banks permission keys used by the UI (catalog `cash.*`, `ar.*`, `ap.*`; legacy menus 7, 16–24 and the bank,
 * cheque, card, guarantee, credit, petty-cash and forecast screens). The API checks the same keys.
 */
export const cashPermissions = {
  bankView: "cash.bank.view",
  bankCreate: "cash.bank.create",
  bankUpdate: "cash.bank.update",
  bankDelete: "cash.bank.delete",
  cashAccountView: "cash.company_bank.view",
  cashAccountCreate: "cash.company_bank.create",
  cashAccountUpdate: "cash.company_bank.update",
  cashAccountDelete: "cash.company_bank.delete",
  chequeBookView: "cash.cheque_book.view",
  chequeBookCreate: "cash.cheque_book.create",
  chequeBookUpdate: "cash.cheque_book.update",
  chequeBookDelete: "cash.cheque_book.delete",
  cardAcquirerView: "cash.card_acquirer.view",
  cardAcquirerCreate: "cash.card_acquirer.create",
  cardAcquirerUpdate: "cash.card_acquirer.update",
  cardAcquirerDelete: "cash.card_acquirer.delete",
  pettyCashFundView: "cash.petty_cash_fund.view",
  pettyCashFundCreate: "cash.petty_cash_fund.create",
  pettyCashFundUpdate: "cash.petty_cash_fund.update",
  pettyCashFundDelete: "cash.petty_cash_fund.delete",
  settingsView: "cash.settings.view",
  settingsUpdate: "cash.settings.update",
  receiptView: "cash.receipt_voucher.view",
  receiptPrint: "cash.receipt_voucher.print",
  paymentPrint: "cash.payment_voucher.print",
  receiptCreate: "cash.receipt_voucher.create",
  receiptUpdate: "cash.receipt_voucher.update",
  receiptPost: "cash.receipt_voucher.post",
  receiptDelete: "cash.receipt_voucher.delete",
  receiptReverse: "cash.receipt_voucher.reverse",
  receiptImport: "cash.receipt_voucher.import",
  receiptAllocate: "cash.receipt_voucher.allocate",
  receiptOverride: "cash.receipt_voucher.override_cheque_limit",
  paymentView: "cash.payment_voucher.view",
  paymentCreate: "cash.payment_voucher.create",
  paymentUpdate: "cash.payment_voucher.update",
  paymentPost: "cash.payment_voucher.post",
  paymentDelete: "cash.payment_voucher.delete",
  paymentReverse: "cash.payment_voucher.reverse",
  paymentAllocate: "cash.payment_voucher.allocate",
  paymentOverride: "cash.payment_voucher.override_credit_limit",
  chequeView: "cash.cheque_list.view",
  chequePost: "cash.cheque_list.post",
  /** Prints an issued cheque on its bank's layout (OA-F8). */
  chequePrint: "cash.cheque_list.print",
  chequeReverse: "cash.cheque_list.reverse",
  promissoryView: "cash.promissory_list.view",
  promissoryPost: "cash.promissory_list.post",
  guaranteeChequeView: "cash.guarantee_cheque_list.view",
  guaranteeChequePost: "cash.guarantee_cheque_list.post",
  depositView: "cash.bank_deposit.view",
  depositCreate: "cash.bank_deposit.create",
  depositUpdate: "cash.bank_deposit.update",
  depositPost: "cash.bank_deposit.post",
  depositDelete: "cash.bank_deposit.delete",
  depositReverse: "cash.bank_deposit.reverse",
  transferView: "cash.cash_transfer.view",
  transferCreate: "cash.cash_transfer.create",
  transferUpdate: "cash.cash_transfer.update",
  transferPost: "cash.cash_transfer.post",
  transferDelete: "cash.cash_transfer.delete",
  transferReverse: "cash.cash_transfer.reverse",
  cashCountView: "cash.cash_count.view",
  cashCountCreate: "cash.cash_count.create",
  cashCountUpdate: "cash.cash_count.update",
  cashCountPost: "cash.cash_count.post",
  cashCountDelete: "cash.cash_count.delete",
  cashCountReverse: "cash.cash_count.reverse",
  reconciliationView: "cash.bank_reconciliation.view",
  reconciliationCreate: "cash.bank_reconciliation.create",
  reconciliationUpdate: "cash.bank_reconciliation.update",
  reconciliationPost: "cash.bank_reconciliation.post",
  reconciliationDelete: "cash.bank_reconciliation.delete",
  reconciliationReverse: "cash.bank_reconciliation.reverse",
  reconciliationImport: "cash.bank_reconciliation.import",
  cardSettlementView: "cash.visa_list.view",
  cardSettlementCreate: "cash.visa_list.create",
  cardSettlementUpdate: "cash.visa_list.update",
  cardSettlementPost: "cash.visa_list.post",
  cardSettlementDelete: "cash.visa_list.delete",
  cardSettlementReverse: "cash.visa_list.reverse",
  debitNoteView: "ar.debit_note.view",
  debitNoteCreate: "ar.debit_note.create",
  debitNoteUpdate: "ar.debit_note.update",
  debitNotePost: "ar.debit_note.post",
  debitNoteDelete: "ar.debit_note.delete",
  debitNoteReverse: "ar.debit_note.reverse",
  creditNoteView: "ar.credit_note.view",
  creditNoteCreate: "ar.credit_note.create",
  creditNoteUpdate: "ar.credit_note.update",
  creditNotePost: "ar.credit_note.post",
  creditNoteDelete: "ar.credit_note.delete",
  creditNoteReverse: "ar.credit_note.reverse",
  paymentRequestView: "ap.payment_request.view",
  paymentRequestCreate: "ap.payment_request.create",
  paymentRequestUpdate: "ap.payment_request.update",
  paymentRequestDelete: "ap.payment_request.delete",
  paymentRequestConvert: "ap.payment_request.convert",
  debitNoteRequestView: "ar.debit_note_request.view",
  debitNoteRequestCreate: "ar.debit_note_request.create",
  debitNoteRequestUpdate: "ar.debit_note_request.update",
  debitNoteRequestDelete: "ar.debit_note_request.delete",
  debitNoteRequestConvert: "ar.debit_note_request.convert",
  creditNoteRequestView: "ar.credit_note_request.view",
  creditNoteRequestCreate: "ar.credit_note_request.create",
  creditNoteRequestUpdate: "ar.credit_note_request.update",
  creditNoteRequestDelete: "ar.credit_note_request.delete",
  creditNoteRequestConvert: "ar.credit_note_request.convert",
  prepaidView: "cash.advance_payment_voucher.view",
  prepaidCreate: "cash.advance_payment_voucher.create",
  prepaidUpdate: "cash.advance_payment_voucher.update",
  prepaidPost: "cash.advance_payment_voucher.post",
  prepaidDelete: "cash.advance_payment_voucher.delete",
  prepaidReverse: "cash.advance_payment_voucher.reverse",
  prepaidRun: "cash.advance_payment_voucher.run",
  guaranteeView: "cash.letter_of_guarantee.view",
  guaranteeCreate: "cash.letter_of_guarantee.create",
  guaranteeUpdate: "cash.letter_of_guarantee.update",
  guaranteePost: "cash.letter_of_guarantee.post",
  guaranteeDelete: "cash.letter_of_guarantee.delete",
  guaranteeReverse: "cash.letter_of_guarantee.reverse",
  creditLetterView: "cash.letter_of_credit.view",
  creditLetterCreate: "cash.letter_of_credit.create",
  creditLetterUpdate: "cash.letter_of_credit.update",
  creditLetterPost: "cash.letter_of_credit.post",
  creditLetterDelete: "cash.letter_of_credit.delete",
  creditLetterReverse: "cash.letter_of_credit.reverse",
  pettyCashView: "cash.petty_cash_payment.view",
  pettyCashCreate: "cash.petty_cash_payment.create",
  pettyCashUpdate: "cash.petty_cash_payment.update",
  pettyCashPost: "cash.petty_cash_payment.post",
  pettyCashDelete: "cash.petty_cash_payment.delete",
  pettyCashReverse: "cash.petty_cash_payment.reverse",
  replenishmentView: "cash.petty_cash_replenishment.view",
  replenishmentCreate: "cash.petty_cash_replenishment.create",
  replenishmentUpdate: "cash.petty_cash_replenishment.update",
  replenishmentPost: "cash.petty_cash_replenishment.post",
  replenishmentDelete: "cash.petty_cash_replenishment.delete",
  replenishmentReverse: "cash.petty_cash_replenishment.reverse",
  forecastView: "cash.cash_flow_forecast.view",
  forecastUpdate: "cash.cash_flow_forecast.update",
} as const;
